import { REMOTE_CONFIG_KEYS } from '@puzzlemania/remote-config';
/**
 * Maps a level-complete event's difficulty label to the matching XP remote-config key.
 * Game-agnostic: Block Jam's `difficulty` and Water Sort's `difficulty_band` both use
 * 'Easy'|'Medium'|'Hard'|'Expert' (case-sensitive, matching each game's own type), except
 * Water Sort also has a 5th 'Beginner' tier with no dedicated XP key — reuses the EASY
 * value since it's the lowest tier and no new remote-config key was scoped for it.
 * Any other/unrecognized value also falls back to EASY.
 */
export function xpLevelCompleteKeyForDifficulty(difficulty) {
    switch (difficulty) {
        case 'Medium':
            return REMOTE_CONFIG_KEYS.XP_LEVEL_COMPLETE_MEDIUM;
        case 'Hard':
            return REMOTE_CONFIG_KEYS.XP_LEVEL_COMPLETE_HARD;
        case 'Expert':
            return REMOTE_CONFIG_KEYS.XP_LEVEL_COMPLETE_EXPERT;
        case 'Easy':
        case 'Beginner':
        default:
            return REMOTE_CONFIG_KEYS.XP_LEVEL_COMPLETE_EASY;
    }
}
const XP_DAILY_REWARD_DAY_KEYS = {
    1: REMOTE_CONFIG_KEYS.XP_DAILY_REWARD_DAY_1,
    2: REMOTE_CONFIG_KEYS.XP_DAILY_REWARD_DAY_2,
    3: REMOTE_CONFIG_KEYS.XP_DAILY_REWARD_DAY_3,
    4: REMOTE_CONFIG_KEYS.XP_DAILY_REWARD_DAY_4,
    5: REMOTE_CONFIG_KEYS.XP_DAILY_REWARD_DAY_5,
    6: REMOTE_CONFIG_KEYS.XP_DAILY_REWARD_DAY_6,
    7: REMOTE_CONFIG_KEYS.XP_DAILY_REWARD_DAY_7,
};
/** Falls back to day 1's key for any out-of-range day (defensive — the cycle is 1-7). */
export function xpDailyRewardKeyForDay(day) {
    return XP_DAILY_REWARD_DAY_KEYS[day] ?? REMOTE_CONFIG_KEYS.XP_DAILY_REWARD_DAY_1;
}
